import React, { useEffect } from 'react'
import SwitchInput from '../../components/UI/SwitchInput'
import { IConfigPageProps } from './types'
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";

export const switchOptions = {
  check: 'true',
  uncheck: 'false',
}

function Features(props: IConfigPageProps) {
  const {canEdit} = useAuth()

  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'features'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  return (
    <>
      <SwitchInput
        label="Lobby´s tournament icon enabled" 
        onChange={(e) => props.setConfig(e, 'TOURNAMENT_ENABLED')}
        options={switchOptions}
        value={props.config.TOURNAMENT_ENABLED}
        disabled={!canEdit}
      />
      <SwitchInput
        label="Prohibits concurrent reports for the same user" 
        onChange={(e) => props.setConfig(e, 'ENFORCE_NO_SIMULTANEOUS_REPORT_FOR_USER')}
        options={switchOptions}
        value={props.config.ENFORCE_NO_SIMULTANEOUS_REPORT_FOR_USER}
        disabled={!canEdit}
      />
      <SwitchInput
        label="Prohibits concurrent execution of critical reports for all users" 
        onChange={(e) => props.setConfig(e, 'ENFORCE_NO_SIMULTANEOUS_CRITICAL_REPORT_FOR_ALL_USERS')}
        options={switchOptions}
        value={props.config.ENFORCE_NO_SIMULTANEOUS_CRITICAL_REPORT_FOR_ALL_USERS}
        disabled={!canEdit}
      />
      <SwitchInput
        label="Report - Financial/Monthly Reports - Disable 'Pull-Tabs' Game Type option"
        onChange={(e) => props.setConfig(e, 'REPORT_MONTHLY_REPORT_DISABLE_PULLTABS')}
        options={switchOptions}
        value={props.config.REPORT_MONTHLY_REPORT_DISABLE_PULLTABS}
        disabled={!canEdit}
      />
      <SwitchInput
        label="Lobby V2" 
        onChange={(e) => props.setConfig(e, 'LOBBY_V2_ENABLED')}
        options={switchOptions}
        value={props.config.LOBBY_V2_ENABLED}
        disabled={!canEdit}
      />
      <SwitchInput
        label="Dynamic Bundle Downloads"
        onChange={(e) => props.setConfig(e, 'DYNAMIC_BUNDLE_DOWNLOAD')}
        options={switchOptions}
        value={props.config.DYNAMIC_BUNDLE_DOWNLOAD}
        disabled={!canEdit}
      />
      <SwitchInput
        label="Location Specific Lobby Order"
        onChange={(e) => props.setConfig(e, 'LOCATION_SPECIFIC_LOBBY_ORDER')}
        options={switchOptions}
        value={props.config.LOCATION_SPECIFIC_LOBBY_ORDER}
        disabled={!canEdit}
      />
    </>
  )
}

export default Features